import { render } from "./SetupBilling.vue?vue&type=template&id=015e09f8&scoped=true"
import script from "./SetupBilling.vue?vue&type=script&lang=js"
export * from "./SetupBilling.vue?vue&type=script&lang=js"

import "./SetupBilling.vue?vue&type=style&index=0&id=015e09f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015e09f8"]])

export default __exports__